export default __webpack_public_path__ + "8f733d3ac59c8ce2272e28d23fab8f98.png";